/* SÁRO pre-order checkbox in the cart drawer and cart page (markup: snippets/saro-preorder-ack.liquid).
   - Shows the box only when a pre-order line is in the cart (lines with data-sv-preorder)
   - Blocks every checkout button in that cart until it's ticked
   - Hides the cart's express checkout buttons while a pre-order is in the cart (they would skip the box)
   - Saves the tick as the cart attribute "Pre-order acknowledged" (shows on the order in admin) */
(function () {
  'use strict';
  if (window.SaroPreorderCartLoaded) return;
  window.SaroPreorderCartLoaded = true;

  var ATTR = 'Pre-order acknowledged';

  function post(url, data) {
    return fetch(url, {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(data)
    }).catch(function () {});
  }
  function saveAttr(on, input) {
    var attrs = {};
    attrs[ATTR] = on ? input.value : '';
    return post('/cart/update.js', { attributes: attrs });
  }

  function forms() { return Array.prototype.slice.call(document.querySelectorAll('form')).filter(function (f) { return f.querySelector('[data-saro-po-ack]'); }); }

  function poLines(form) { return form.querySelectorAll('[data-sv-preorder]'); }

  function update(form) {
    var box = form.querySelector('[data-saro-po-ack]');
    if (!box) return;
    var input = box.querySelector('[data-saro-po-ack-input]');
    var lines = poLines(form);
    var has = lines.length > 0;
    box.hidden = !has;
    form.classList.toggle('saro-has-po', has);
    form.querySelectorAll('.additional-checkout-buttons').forEach(function (el) { el.style.display = has ? 'none' : ''; });
    if (has) {
      var msg = (lines[0].getAttribute('data-sv-preorder') || '').replace(/^Receive\s*/i, '').trim();
      var when = box.querySelector('[data-saro-po-ack-when]');
      if (when) when.textContent = msg ? ' (expected ' + msg + ')' : '';
    } else if (input.checked) {
      input.checked = false;
      saveAttr(false, input);
    }
    if (!has || input.checked) { box.classList.remove('is-error'); box.querySelector('[data-saro-po-ack-err]').hidden = true; }
  }

  function updateAll() { forms().forEach(update); }

  function blocked(form) {
    if (!form || !form.querySelector('[data-saro-po-ack]')) return false;
    update(form);
    var box = form.querySelector('[data-saro-po-ack]');
    var input = box.querySelector('[data-saro-po-ack-input]');
    if (box.hidden || input.checked) return false;
    box.classList.add('is-error');
    box.querySelector('[data-saro-po-ack-err]').hidden = false;
    try { box.scrollIntoView({ behavior: 'smooth', block: 'center' }); } catch (e) { box.scrollIntoView(); }
    return true;
  }

  // Capture on document so this runs before the theme's and sv-cart.js's checkout handlers
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[name="checkout"]');
    if (!btn) return;
    if (blocked(btn.form || btn.closest('form'))) { e.preventDefault(); e.stopImmediatePropagation(); }
  }, true);
  document.addEventListener('submit', function (e) {
    var submitter = e.submitter || document.activeElement;
    if (!submitter || submitter.name !== 'checkout') return;
    if (blocked(e.target)) { e.preventDefault(); e.stopImmediatePropagation(); }
  }, true);

  document.addEventListener('change', function (e) {
    var input = e.target.closest && e.target.closest('[data-saro-po-ack-input]');
    if (!input) return;
    // keep both boxes (drawer + cart page) in step
    document.querySelectorAll('[data-saro-po-ack-input]').forEach(function (i) { i.checked = input.checked; });
    saveAttr(input.checked, input);
    updateAll();
  });

  function watch() {
    forms().forEach(function (form) {
      var products = form.querySelector('[data-products]');
      if (products && !products._saroPo) {
        products._saroPo = true;
        new MutationObserver(function () { clearTimeout(products._saroT); products._saroT = setTimeout(function () { update(form); }, 30); })
          .observe(products, { childList: true, subtree: true });
      }
      // start ticked if the customer already agreed on this cart
      fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(function (cart) {
        var on = !!(cart.attributes && cart.attributes[ATTR]);
        form.querySelectorAll('[data-saro-po-ack-input]').forEach(function (i) { i.checked = on; });
        update(form);
      }).catch(function () {});
      update(form);
    });
  }

  document.addEventListener('cart:updated', function () { setTimeout(updateAll, 400); });
  document.addEventListener('ajaxProduct:added', function () { setTimeout(updateAll, 600); });
  document.addEventListener('cart:open', function () { setTimeout(updateAll, 300); });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', watch); else watch();
})();